<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :is-form-fetched="isFetched"
    :module-enabler="moduleEnabler"
    :has-buttons="false"
  >
    <template #[`dataTree.input`]>
      <v-row no-gutters>
        <v-col cols="6">
          <data-tree-settings-list />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataTreeSettingsList from '@/components/DataTreeSettingsList';

export default {
  name: 'DataTreeSettings',
  components: { AdminWrapper, DataTreeSettingsList },
  computed: {
    additionalModuleName: get('admin/additionalModules@DATA_TREE_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@data_tree_module_enabled'),
    inputs() {
      return [
        {
          name: 'dataTree',
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'data_tree_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getDataTrees: call('dataTree/getDataTrees'),
    async init() {
      await Promise.all([this.getDataTrees(), this.getDataSources({ with_attributes_schema: true })]);
      this.isFetched = true;
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFetched = true;
    }
  },
};
</script>
